import { Component, Injector, OnInit } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Platform } from '@ionic/angular';
import { SettingService } from 'src/pages/setting/services/setting/setting.service';
import { Extender } from 'src/shared/helpers/extender';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent extends Extender implements OnInit {
  public color: string = '#009688';
  public pages: Array<{
    title: string;
    component: any;
    icon: string;
    image: boolean;
    show: boolean;
  }> = [];

  constructor(
    protected injector: Injector,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private settingService: SettingService
  ) {
    super(injector);
    this.initializeApp();
  }

  public initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  public ngOnInit(): void {
    this.darkModeCheck();
    this.setLanguage();
    this.auth$.user$.subscribe((contact) => {
      if (contact) {
        this.setLanguage(contact.uid);
        this.pages = [
          {
            title: 'Profile',
            component: this.routes.profile,
            icon: contact.profileImage || null,
            image: true,
            show: false
          },
          {
            title: 'Dashboard',
            component: this.routes.dashboard,
            icon: 'calendar-full',
            image: false,
            show: false
          },
          {
            title: 'News',
            component: this.routes.feed,
            icon: 'picture',
            image: false,
            show: false
          },
          {
            title: 'People',
            component: this.routes.people,
            icon: 'users',
            image: false,
            show: false
          },
          {
            title: 'Chat',
            component: this.routes.chat,
            icon: 'envelope',
            image: false,
            show: false
          },
          {
            title: 'Settings',
            component: this.routes.setting,
            icon: 'cog',
            image: false,
            show: false
          },
          {
            title: 'Logout',
            component: 'logout',
            icon: 'lock',
            image: false,
            show: false
          }
        ];
      }
    });
  }

  /**
   * @description set language from information stored in local storage
   * @method setLanguage
   * @public
   * @returns void
   */
  public setLanguage(uid?): void {
    if (uid) {
    this.settingService.getUserPreference(uid).subscribe((lang) => {
      if (lang) {
        this.translate.setDefaultLang(lang.language);
        this.translate.use(lang.language);
      }
    });
  } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
    }

  }

  /**
   * @description triggered when menu is clicked. navigates to the page that is selected.
   * @method openPage
   * @param page
   * @public
   */
  public openPage(page) {
    if (page.component === 'logout') {
      this.auth$.signOut().then(() => {
        this.gotoPage(this.routes.auth);
      });
    } else {
      this.gotoPage(page.component);
    }
  }

  /**
   * @description creates a listener to set app to dark mode if device preference is set to dark mode.
   * @method darkModeCheck
   * @public
   */
  public darkModeCheck() {
    // Use matchMedia to check the user preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    toggleDarkTheme(prefersDark.matches);

// Listen for changes to the prefers-color-scheme media query
    prefersDark.addListener((mediaQuery) => toggleDarkTheme(mediaQuery.matches));

// Add or remove the "dark" class based on if the media query matches
    function toggleDarkTheme(shouldAdd) {
      document.body.classList.toggle('dark', shouldAdd);
    }
  }

}
